import { SurfaceAccessWorkspace } from '@/components/surface/SurfaceAccessWorkspace';

export default function SurfaceAccessAdminPage() {
  return <SurfaceAccessWorkspace mode="platform" />;
}
